import { render, staticRenderFns } from "./EditarGeneral.vue?vue&type=template&id=30613da1&"
import script from "./EditarGeneral.vue?vue&type=script&lang=ts&"
export * from "./EditarGeneral.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('30613da1', component.options)
    } else {
      api.reload('30613da1', component.options)
    }
    module.hot.accept("./EditarGeneral.vue?vue&type=template&id=30613da1&", function () {
      api.rerender('30613da1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/MovimientoDispositivos/EditarGeneral.vue"
export default component.exports